import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  groupList: [],
  codebookTypeGroup: null,
  loading: false,
  error: undefined,
  group: {},
};

const codebookTypeGroupSlice = createSlice({
  name: 'codebookTypeGroup',
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    actionError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    setCodebookTypeGroupList(state, action) {
      state.groupList = action.payload;
      state.loading = false;
    },
    addCodebookTypeGroup(state, action) {
      state.groupList = [action.payload].concat(state.groupList);
      state.group = action.payload;
      state.error = undefined;
      state.loading = false;
    },
    updateCodebookTypeGroup(state, action) {
      state.groupList = state.groupList.map((codebookTypeGroup) =>
        codebookTypeGroup.id === action.payload.id
          ? action.payload
          : codebookTypeGroup
      );
      state.group = action.payload;
      state.error = undefined;
      state.loading = false;
    },
    deleteCodebookTypeGroup(state, action) {
      state.groupList = state.groupList.filter(
        (codebookTypeGroup) => codebookTypeGroup.id !== action.payload
      );
      state.error = undefined;
      state.loading = false;
    },
    setCodebookTypeGroup(state, action) {
      state.group = action.payload;
      state.error = undefined;
      state.loading = false;
    },
    fetchAllCodebookTypeGroup(state, action) {
      state.groupList = action.payload;
      state.error = undefined;
      state.loading = false;
    },
    clearCodebookTypeGroupList(state) {
      state.groupList = [];
      state.group = {};
      state.error = undefined;
      state.loading = false;
    },
    clearCodebookTypeGroup(state) {
      state.group = {};
    },
  },
});

export const codebookTypeGroupActions = codebookTypeGroupSlice.actions;

export default codebookTypeGroupSlice.reducer;
